const REM_TO_PX = 0.0625;
const GRID_SIZE = 8;
export const sizeToRem = size => `${size * GRID_SIZE * REM_TO_PX}rem`;
export const pxToRem = px => `${(px * REM_TO_PX).toFixed(3)}rem`;